module.exports = __webpack_public_path__ + "img/c1.9716dbfe.png";